import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalTransferDestinationQuery = graphql(`
  query ClientPortalTransferDestination($id: ID!, $householdId: ID) {
    portfolio(userId: $id, householdId: $householdId) {
      id
      accounts {
        id
        newAccountCustodian
      }
    }
  }
`);

export type ClientPortalTransferDestinationResult = ResultOf<typeof ClientPortalTransferDestinationQuery>;
